import { AuthStateT } from '../types/auth.types'

export const AUTH_STORAGE_TOKEN = 'spark-bpms-token'
export const USER_STORAGE_TOKEN = 'spark-bpms-user-info'

export const DEFAULT_AUTH_STATE: AuthStateT = {
    access_token: '',
    refresh_token: '',
    token_type: '',
    expires_in: 0,
}
